import React from 'react';
import PageSection from '../../components/PageSection';
import DataTable from '../../components/DataTable';

import { useAPI } from '../../api';
import { Route, Routes } from 'react-router-dom';
import RoleContainer from './RoleContainer';
import { Role } from 'types';
import { OrgContextLink, useOrgContext } from 'components/OrgContextProvider';

const RolesSettingsContainer = () => {
	const api = useAPI();
	const ctx = useOrgContext();

	const [roles, setRoles] = React.useState<Role[]>([]);

	const loadRoles = () => {
		api.get<Role[]>(`${ctx?.apiBase}/roles`)
		.then(json => setRoles(json));
	}

	React.useEffect(() => {
		loadRoles();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function deleteRole(roleID: string) {
		if (window.confirm(`Delete role ${roleID}?`)) {
			api.delete(`${ctx?.apiBase}/roles/${roleID}`)
			.then(loadRoles);
		}
	};

	return (
		<div>
			<PageSection title="Roles Settings" level={2} />

			<Routes>
				<Route path="/" element={
					<div>
						<PageSection title="Roles">
							<DataTable<Role>
								data={roles}
								columns={[
									{ label: 'Role', noWrap: true, render: (role) => (<OrgContextLink to={`/settings/roles/${role.id}`}>{role.name}</OrgContextLink>) },
									{ label: 'ID', noWrap: true, key: 'id' },
									{ label: 'Description', key: 'description' },
									{ label: 'Permissions', key: 'permissions', render: (row) => row.permissions?.join(', ') }
								]}
								tools={[
									(role) => role.builtin ? null : (<button className="link" onClick={() => deleteRole(role.id)}>Delete</button>)
								]}
								tableTools={[
									() => (<OrgContextLink to={`/settings/roles/new`}>Create new role...</OrgContextLink>)
								]}
							/>
						</PageSection>
					</div>
				} />

				<Route path="/:roleID" element={<RoleContainer onChanged={loadRoles} />} />
			</Routes>
		</div>
	);
}

export default RolesSettingsContainer;
